export const FAVORITE_LIST = "FAVORITE_LIST"